import React from "react";

// --- Header Component ---
export const InvoiceHeader = () => {
  const company = {
    name: "JANANI EXPRESS PARCEL SERVICE",
    tagline: "JANANI TRANSPORT",
    subTitle: "Motor Parts Inventory Management System",
    address: "Head Office: Meherba plaza, 33 Topkhan Road, Dhaka-1000",
    contact: "HOT LINE: 09642222555 | info@jananiexpress.com",
  };
  return (
<div className="border-b border-gray-300 p-6">
  <div className="flex items-start gap-4">
    {/* Logo Container */}
    <div className="w-16 h-16 border border-gray-400 flex items-center justify-center text-xs text-gray-500">
      <img
        className="h-14 w-auto mx-auto"
        src={require("../../../assets/janani_logo.jpg")}
        alt="Janani Transport Logo"
      />
    </div>

    {/* Company Info */}
    <div className="flex-1 text-center">
      <h1 className="text-2xl font-bold tracking-wide">{company?.name}</h1>
      <h2 className="text-lg font-semibold">{company?.tagline}</h2>
      <p className="text-sm font-medium">{company?.subTitle}</p>
      <p className="text-sm mt-2">{company?.address}</p>
      <p className="text-sm">{company?.contact}</p>
    </div>
  </div>
</div>

  );
};
